import React, { useState, useEffect, useRef } from 'react';
import runMyTransportLogo from "../../assets/runmytransport.png";
import './Clients.css';

const Clients = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [cardWidth, setCardWidth] = useState(330);
  const trackRef = useRef(null);
  const carouselRef = useRef(null); // NEW
  const intervalRef = useRef(null);

  // Sample client data - you can replace these with actual client logos
  const clients = [
    { id: 1, name: "", logo: "https://creditbureauasia.com/wp-content/uploads/2020/03/sccb-logo_fc-01.png" },
    { id: 2, name: "", logo: "https://logowik.com/content/uploads/images/dun-bradstreet2297.jpg" },
    { id: 3, name: "", logo: "https://alaintesting.com.my/wp-content/uploads/2023/05/SSM-reg-no.-2015010036161128948-W-1-768x279.png" },
    { id: 4, name: "", logo: "https://new.onebloc.io/images/logo.png" },
    { id: 5, name: "", logo: "https://vedantenterprisesglb.com/static/media/logo.0137a38aa9da51194a5c.png" },
    { id: 6, name: "", logo: "https://upload.wikimedia.org/wikipedia/en/c/c2/University_of_Agricultural_Science_Raichuru_logo.jpg" },
    { id: 7, name: "", logo: "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjulod4ilNG199gjHLvAJZ4cHdyyEDouznh_w9lJVrkztwFyMGQc8-AZYI3B5hvO1vzHN7lkUjJtx466IMxPmSwG6ZyzXhiX_7ZrnKOBYgOxD8V7NXytqYzjjF8vZen8RzfI06FEMuHUP9I/s1600/University+of+Horticultural+Sciences,+Bagalkot.jpg" },
    // { id: 8, name: "", logo: "https://malnadnests.com/wp-content/uploads/2025/12/malnadnests_new_logo-150x150.jpg.webp" },
    { id: 9, name: "", logo: "https://www.reshmihospital.com/static/media/reshmi-logo.1f098df7c6b29459af63.jpeg" },
    // { id: 10, name: "", logo: "https://rathihospital.in/static/media/logo.31face54f1f9417d8749.png" },
    // { id: 11, name: "", logo: "https://shreevidyacollege.in/static/media/srividyaLogo.510045784e9c86ba85d6.jpg" },
    { id: 12,name: "Run My Transport", logo: runMyTransportLogo }

  ];

  const maxIndex = clients.length - 1;

  // Calculate card width based on screen size
  useEffect(() => {
    const updateCardWidth = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth <= 768) {
        // Use the actual carousel viewport width so one full card is visible
        const viewport =
          carouselRef.current?.getBoundingClientRect().width ?? screenWidth;
        setCardWidth(Math.floor(viewport)); // exact fit
      } else if (screenWidth <= 1024) {
        setCardWidth(270);
      } else {
        setCardWidth(330);
      }
    };

    updateCardWidth();
    window.addEventListener('resize', updateCardWidth);
    return () => window.removeEventListener('resize', updateCardWidth);
  }, []);

  // Auto-scroll functionality
  useEffect(() => {
    if (!isPaused) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prevIndex => {
          if (prevIndex >= maxIndex) {
            return 0;
          }
          return prevIndex + 1;
        });
      }, 3000); // Change slide every 3 seconds
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isPaused, maxIndex]);

  // Update transform when currentIndex changes
  useEffect(() => {
    if (trackRef.current) {
      const translateX = -(currentIndex * (cardWidth + gapForCurrentViewport()));
      trackRef.current.style.transform = `translateX(${translateX}px)`;
    }
  }, [currentIndex, cardWidth]);
  const gapForCurrentViewport = () => {
    const w = window.innerWidth;
    if (w <= 480) return 0;       // matches CSS @max-480
    if (w <= 768) return 0;       // matches CSS @max-768
    if (w <= 1024) return 20;     // matches CSS @max-1024
    return 30;                    // desktop
  };
  const handlePrevious = () => {
    setIsPaused(true);
    setCurrentIndex(prevIndex => {
      if (prevIndex <= 0) {
        return maxIndex;
      }
      return prevIndex - 1;
    });

    // Resume auto-scroll after 5 seconds
    setTimeout(() => setIsPaused(false), 5000);
  };

  const handleNext = () => {
    setIsPaused(true);
    setCurrentIndex(prevIndex => {
      if (prevIndex >= maxIndex) {
        return 0;
      }
      return prevIndex + 1;
    });

    // Resume auto-scroll after 5 seconds
    setTimeout(() => setIsPaused(false), 5000);
  };

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <section className="clients">
      <div className="clients-container">
        <div className="clients-header">
          <h2 className="clients-title">Some of our customers</h2>
          <div className="clients-navigation">
            <button
              className="nav-btn prev-btn"
              aria-label="Previous"
              onClick={handlePrevious}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button
              className="nav-btn next-btn"
              aria-label="Next"
              onClick={handleNext}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>

        <div
          className="clients-carousel"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          ref={carouselRef} // NEW

        >
          <div className="clients-track" ref={trackRef}>
            {/* First set of clients */}
            {clients.map((client) => (
              <div key={client.id} className="client-card">
                <div className="client-logo">
                  <img src={client.logo} alt={client.name || "Client logo"} />
                </div>
              </div>
            ))}
            {/* Duplicate set for smooth infinite loop */}
            {clients.map((client) => (
              <div key={`${client.id}-duplicate`} className="client-card">
                <div className="client-logo">
                  <img src={client.logo} alt={client.name || "Client logo"} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Progress indicators */}
        <div className="clients-indicators">
          {clients.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => {
                setIsPaused(true);
                setCurrentIndex(index);
                setTimeout(() => setIsPaused(false), 5000);
              }}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;